module.exports = __webpack_public_path__ + "assets/mention-down.798a86d5.svg";